(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pluqe-wall-preview"] && !Shopify.designMode) return;
  try {
    
  const publishPluqeEvent = (name, data) => {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (error) {
      return;
    }
  };

  document.querySelectorAll('[data-pluqe-ar]').forEach((root) => {
    if (root.dataset.pluqeArReady === 'true') return;
    root.dataset.pluqeArReady = 'true';

    const userAgent = navigator.userAgent;
    const isIPadDesktopMode = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const isIOS = /iPad|iPhone|iPod/i.test(userAgent) || isIPadDesktopMode;
    const isAndroid = /Android/i.test(userAgent);
    // Rise17追記: Instagram / Facebookアプリ内ブラウザ（WebView）を判定する。
    // これらのWebViewのUser-Agentには通常"Safari"の文字列が含まれるため、
    // この判定を先に行わないと後段のisSafariが誤ってtrueになってしまう。
    const isInAppBrowser = /Instagram|FBAN|FBAV|FBIOS|FB_IAB/i.test(userAgent);
    const isSafari = /Safari/i.test(userAgent) && !/(CriOS|FxiOS|EdgiOS|OPiOS)/i.test(userAgent) && !isInAppBrowser;
    const device = isAndroid ? 'android' : isIOS ? 'ios' : 'desktop';
    // Rise17修正: パネル判定の優先順位を明示する。
    // Android → iOS×Instagram/Facebook内ブラウザ(ios-inapp) → iOS×Safari(ios-safari)
    // → その他のiOSブラウザ(ios-browser) → デスクトップ、の順で評価する。
    // isInAppBrowserの判定をisSafariより先に評価することで、isSafariの実装が
    // 将来変わった場合でもInstagram/Facebookが誤ってios-safariへ振り分けられないようにする。
    const computedPanel = isAndroid
      ? 'android'
      : isIOS && isInAppBrowser
      ? 'ios-inapp'
      : isIOS && isSafari
      ? 'ios-safari'
      : isIOS
      ? 'ios-browser'
      : 'desktop';

    // Rise17診断用（一時機能・公開前に削除予定）: URLに pluqe_debug=1 が付いている場合のみ
    // 診断モードを有効化する。パラメータが無い通常アクセスでは isPluqeDebugMode は常にfalseのままとなり、
    // 以降の診断パネル生成・パネル強制指定・ログ処理は一切実行されない（DOMにも一切出力されない）。
    let isPluqeDebugMode = false;
    let pluqeDebugForcedPanel = null;
    try {
      const pluqeDebugParams = new URLSearchParams(window.location.search);
      isPluqeDebugMode = pluqeDebugParams.get('pluqe_debug') === '1';
      if (isPluqeDebugMode) {
        const requestedPanel = pluqeDebugParams.get('pluqe_debug_panel');
        const validDebugPanels = ['ios-inapp', 'ios-safari', 'ios-browser', 'android', 'desktop'];
        if (requestedPanel && validDebugPanels.indexOf(requestedPanel) !== -1) {
          pluqeDebugForcedPanel = requestedPanel;
        }
      }
    } catch (error) {
      isPluqeDebugMode = false;
      pluqeDebugForcedPanel = null;
    }

    // pluqe_debug=1 かつ有効なpluqe_debug_panelが指定された場合のみ、表示パネルを一時的に上書きする。
    // それ以外（通常アクセス、または不正なパネル名）では既存のcomputedPanelがそのまま採用され、
    // 通常のパネル分岐ロジックには一切影響しない。
    const panel = pluqeDebugForcedPanel || computedPanel;
    const status = root.querySelector('[data-device-status]');

    root.querySelectorAll('[data-device-panel]').forEach((item) => {
      item.hidden = item.dataset.devicePanel !== panel;
    });

    root.querySelectorAll('[data-ios-content]').forEach((item) => {
      item.hidden = panel !== 'ios-safari';
    });

    if (status) {
      status.textContent = panel === 'android' ? 'Android版 準備中' : panel === 'ios-inapp' || panel === 'ios-browser' ? 'Safariでご利用ください' : 'iPhone版 先行公開';
    }

    const arLaunch = root.querySelector('[data-ar-launch]');
    if (arLaunch) {
      arLaunch.addEventListener('click', () => {
        publishPluqeEvent('pluqe:ar_launch', {
          category: 'ITAZUKE',
          device: 'ios',
          model_version: 'v6'
        });
      });
    }

    // Rise17修正: 「URLをコピー」ボタン。ios-inapp（Instagram/Facebook）と
    // ios-browser（Safari以外の通常iOSブラウザ）の2パネルにそれぞれ独立して存在する。
    // id属性は使わず、各ボタンごとにdata-copy-url-valueを持たせ、結果表示は
    // ボタンの祖先である[data-device-panel]内のdata-copy-url-feedbackへ限定して
    // 表示することで、どちらのパネルのボタンを押しても正しいfeedback領域にのみ反映される。
    // Clipboard APIが使えない場合は、非表示のtextareaへ書き込み->選択->document.execCommand('copy')による
    // 代替コピー処理を行う。どちらも失敗した場合は、手動コピーを促す文言をfeedback領域に表示する。
    // 自動リダイレクト・別タブ起動・ページ再読み込みは一切行わない。
    root.querySelectorAll('[data-copy-url]').forEach((copyUrlButton) => {
      copyUrlButton.addEventListener('click', () => {
        const url = copyUrlButton.dataset.copyUrlValue || 'https://pluqe.com/pages/wall-preview-ar';
        const panelScope = copyUrlButton.closest('[data-device-panel]') || root;
        const feedback = panelScope.querySelector('[data-copy-url-feedback]');
        const showFeedback = (message) => {
          if (!feedback) return;
          feedback.textContent = message;
          feedback.hidden = false;
        };
        const fallbackCopy = () => {
          try {
            const tempInput = document.createElement('textarea');
            tempInput.value = url;
            tempInput.setAttribute('readonly', '');
            tempInput.style.position = 'fixed';
            tempInput.style.top = '-1000px';
            tempInput.style.left = '-1000px';
            document.body.appendChild(tempInput);
            tempInput.focus();
            tempInput.select();
            const succeeded = document.execCommand && document.execCommand('copy');
            document.body.removeChild(tempInput);
            if (succeeded) {
              showFeedback('URLをコピーしました。Safariに貼り付けて開いてください。');
            } else {
              showFeedback('コピーできませんでした。こちらのURLを手動でコピーしてください：' + url);
            }
          } catch (error) {
            showFeedback('コピーできませんでした。こちらのURLを手動でコピーしてください：' + url);
          }
        };
        try {
          if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            navigator.clipboard.writeText(url).then(() => {
              showFeedback('URLをコピーしました。Safariに貼り付けて開いてください。');
            }).catch(() => {
              fallbackCopy();
            });
          } else {
            fallbackCopy();
          }
        } catch (error) {
          fallbackCopy();
        }
        publishPluqeEvent('pluqe:ar_instagram_copy_url', {
          category: 'ITAZUKE',
          device: device
        });
      });
    });

    const productsView = root.querySelector('[data-products-view]');
    if (productsView) {
      productsView.addEventListener('click', () => {
        publishPluqeEvent('pluqe:ar_products_view', {
          category: 'ITAZUKE',
          device: device
        });
      });
    }

    // Rise17診断用（一時機能・公開前に削除予定）: isPluqeDebugModeがtrueの場合のみ、
    // 診断パネルをJavaScriptで動的に生成してDOMへ追加する。通常アクセス時（pluqe_debug=1が無い場合）は
    // このifブロックの中身が実行されないため、診断表示・コピーボタン・関連ログ処理は一切出力されない。
    if (isPluqeDebugMode) {
      try {
        const arLinkForDebug = root.querySelector('[data-ar-launch]');
        const debugFields = [
          ['navigator.userAgent', userAgent],
          ['navigator.platform', navigator.platform || ''],
          ['navigator.vendor', navigator.vendor || ''],
          ['window.navigator.standalone', String(window.navigator.standalone)],
          ['document.referrer', document.referrer || '(なし)'],
          ['isIOS', String(isIOS)],
          ['isAndroid', String(isAndroid)],
          ['isInAppBrowser', String(isInAppBrowser)],
          ['isSafari', String(isSafari)],
          ['選択されたパネル(panel)', panel],
          ['pluqe_debug_panel(強制指定値)', pluqeDebugForcedPanel || '(指定なし・通常判定を使用)'],
          ['ARリンクの最終href', arLinkForDebug ? arLinkForDebug.href : '(要素なし)'],
          ['location.hostname', window.location.hostname],
          ['location.pathname', window.location.pathname],
          ['location.href', window.location.href]
        ];

        let debugText = 'PLUQE AR 診断情報\n';
        debugFields.forEach(([label, value]) => {
          debugText += label + ': ' + value + '\n';
        });

        const debugPanel = document.createElement('div');
        debugPanel.setAttribute('data-pluqe-debug-panel', '');
        debugPanel.style.cssText = 'margin:28px 0 0;padding:18px;border:2px dashed #c0392b;border-radius:8px;background:#fff8f6;font-family:monospace;font-size:12px;line-height:1.7;word-break:break-all;';

        const debugTitle = document.createElement('p');
        debugTitle.textContent = 'PLUQE AR 診断モード（pluqe_debug=1・公開前削除予定）';
        debugTitle.style.cssText = 'margin:0 0 10px;font-weight:700;color:#c0392b;';
        debugPanel.appendChild(debugTitle);

        const debugList = document.createElement('dl');
        debugList.style.cssText = 'margin:0;';
        debugFields.forEach(([label, value]) => {
          const dt = document.createElement('dt');
          dt.textContent = label;
          dt.style.cssText = 'font-weight:700;margin-top:8px;';
          const dd = document.createElement('dd');
          dd.textContent = value;
          dd.style.cssText = 'margin:0;white-space:pre-wrap;';
          debugList.appendChild(dt);
          debugList.appendChild(dd);
        });
        debugPanel.appendChild(debugList);

        const debugCopyButton = document.createElement('button');
        debugCopyButton.type = 'button';
        debugCopyButton.textContent = '診断情報をコピー';
        debugCopyButton.style.cssText = 'margin-top:16px;padding:9px 16px;border:none;border-radius:6px;background:#c0392b;color:#fff;font-weight:700;font-family:inherit;cursor:pointer;';

        const debugCopyResult = document.createElement('p');
        debugCopyResult.style.cssText = 'margin:10px 0 0;font-size:11px;color:#c0392b;';
        debugCopyResult.hidden = true;

        debugCopyButton.addEventListener('click', () => {
          const showDebugResult = (message) => {
            debugCopyResult.textContent = message;
            debugCopyResult.hidden = false;
          };
          const debugFallbackCopy = () => {
            try {
              const tempInput = document.createElement('textarea');
              tempInput.value = debugText;
              tempInput.setAttribute('readonly', '');
              tempInput.style.position = 'fixed';
              tempInput.style.top = '-1000px';
              tempInput.style.left = '-1000px';
              document.body.appendChild(tempInput);
              tempInput.focus();
              tempInput.select();
              const succeeded = document.execCommand && document.execCommand('copy');
              document.body.removeChild(tempInput);
              showDebugResult(succeeded ? '診断情報をコピーしました。' : 'コピーできませんでした。手動で選択してコピーしてください。');
            } catch (error) {
              showDebugResult('コピーできませんでした。手動で選択してコピーしてください。');
            }
          };
          try {
            if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
              navigator.clipboard.writeText(debugText).then(() => {
                showDebugResult('診断情報をコピーしました。');
              }).catch(() => {
                debugFallbackCopy();
              });
            } else {
              debugFallbackCopy();
            }
          } catch (error) {
            debugFallbackCopy();
          }
        });

        debugPanel.appendChild(debugCopyButton);
        debugPanel.appendChild(debugCopyResult);

        const debugContainer = root.querySelector('.page-width') || root;
        debugContainer.appendChild(debugPanel);
      } catch (error) {
        // 診断パネルの生成に失敗した場合も通常のAR表示・パネル分岐には一切影響させない。
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
